import React, { useState } from "react";
import Navbar from "../components/Navbar";

export default function VehicleLead() {
  const [mode, setMode] = useState(null); // create | check
  const [form, setForm] = useState({});
  const [loading, setLoading] = useState(false);

  const [successMsg, setSuccessMsg] = useState("");
  const [errorMsg, setErrorMsg] = useState("");
  const [leadData, setLeadData] = useState(null);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const resetMessages = () => {
    setSuccessMsg("");
    setErrorMsg("");
    setLeadData(null);
  };

  const createLead = async () => {
  resetMessages();

  // 🔴 FRONTEND VALIDATION (LAKHS CHECK)
  if (
    String(form.minPrice || "").length < 6 ||
    String(form.maxPrice || "").length < 6
  ) {
    setErrorMsg("Amount not in lakhs");
    return;
  }

  setLoading(true);

  try {
    const res = await fetch(
      "https://backend.trustnride.in/api/lead/by-vehicle-number",
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(form),
      }
    );

    const data = await res.json();

    if (!res.ok) {
      setErrorMsg(data.message || "Failed to create lead");
    } else {
      setSuccessMsg("Lead created successfully");
    }
  } catch {
    setErrorMsg("Server error");
  }

  setLoading(false);
};


  const checkLead = async () => {
    resetMessages();
    setLoading(true);

    try {
      const query = form.leadId
        ? `?leadId=${form.leadId}`
        : `?vehicleNumber=${form.vehicleNumber}`;

      const res = await fetch(`https://backend.trustnride.in/api/lead/check${query}`);
      const data = await res.json();

      if (!res.ok) {
        setErrorMsg(data.message || "Lead not found");
      } else {
        setSuccessMsg("Lead found successfully");
        setLeadData(data.data);
      }
    } catch {
      setErrorMsg("Server error");
    }

    setLoading(false);
  };

  const BackButton = () => (
    <button
      className="mb-4 text-sm text-blue-600 underline"
      onClick={() => {
        setMode(null);
        setForm({});
        resetMessages();
      }}
    >
      ← Back
    </button>
  );

  // ✅ Helper to format date only (YYYY-MM-DD)
  const formatDate = (value) => {
    if (!value) return "";
    const d = new Date(value);
    return isNaN(d.getTime()) ? value : d.toISOString().split("T")[0];
  };

  return (
    <div>
      <Navbar />

      <div className="min-h-screen bg-gray-100 flex justify-center items-center p-6">
        <div className="w-full max-w-md space-y-6">

          {/* SUCCESS */}
          {successMsg && (
            <div className="bg-green-100 border border-green-400 text-green-700 p-3 rounded">
              {successMsg}
            </div>
          )}

          {/* ERROR */}
          {errorMsg && (
            <div className="bg-red-100 border border-red-400 text-red-700 p-3 rounded">
              {errorMsg}
            </div>
          )}

          {/* HOME */}
          {!mode && (
            <div className="space-y-4">
              <button
                className="w-full p-4 bg-white border rounded-lg shadow font-semibold"
                onClick={() => setMode("create")}
              >
                ➕ Create Lead
              </button>

              <button
                className="w-full p-4 bg-white border rounded-lg shadow font-semibold"
                onClick={() => setMode("check")}
              >
                🔍 Check Lead
              </button>
            </div>
          )}

          {/* CREATE */}
          {mode === "create" && (
            <div className="bg-white p-6 rounded-lg shadow space-y-4 border">
              <BackButton />

              <h2 className="font-bold text-lg">Create Vehicle Lead</h2>

              <input className="input" name="vehicleNumber" placeholder="Vehicle Number" onChange={handleChange} />
              <input className="input" name="mobileNumber" placeholder="10 Digit Mobile Number" onChange={handleChange} />
              <input className="input" name="minPrice" placeholder="Min Price" onChange={handleChange} />
              <input className="input" name="maxPrice" placeholder="Max Price" onChange={handleChange} />

              <button
                className="w-full bg-blue-600 text-white py-2 rounded"
                onClick={createLead}
                disabled={loading}
              >
                {loading ? "Creating..." : "Create Lead"}
              </button>
            </div>
          )}

          {/* CHECK */}
          {mode === "check" && (
            <div className="bg-white p-6 rounded-lg shadow space-y-4 border">
              <BackButton />

              <h2 className="font-bold text-lg">Check Lead</h2>

              <input className="input" name="leadId" placeholder="Lead ID" onChange={handleChange} />

              <div className="flex items-center gap-2 text-gray-500 text-sm">
                <div className="flex-1 border-t"></div>
                <span>OR</span>
                <div className="flex-1 border-t"></div>
              </div>

              <input className="input" name="vehicleNumber" placeholder="Vehicle Number" onChange={handleChange} />

              <button
                className="w-full bg-green-600 text-white py-2 rounded"
                onClick={checkLead}
                disabled={loading}
              >
                {loading ? "Checking..." : "Check Lead"}
              </button>
            </div>
          )}

          {/* LEAD DETAILS */}
          {leadData && (
            <div className="space-y-4">

              {/* CURRENT PRICE CARD (ONLY PRICE) */}
              <div className="bg-white border rounded-lg p-4 shadow">
                <h3 className="font-semibold mb-1">Current Price</h3>
                <div className="text-lg font-bold text-green-700">
                  ₹{leadData.minPrice} – ₹{leadData.maxPrice}
                </div>
              </div>

              {/* DETAILS TABLE */}
              <div className="bg-white border rounded-lg shadow overflow-x-auto">
                <table className="w-full text-sm">
                  <tbody>
                    {Object.entries(leadData)
                      .filter(([k]) => !["_id", "__v", "minPrice", "maxPrice"].includes(k))
                      .map(([key, value]) => (
                        <tr key={key} className="border-t">
                          <td className="px-3 py-2 font-medium bg-gray-50">
                            {key}
                          </td>
                          <td className="px-3 py-2">
                            {key.toLowerCase().includes("date") ||
                            key.toLowerCase().includes("upto")
                              ? formatDate(value)
                              : String(value)}
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              </div>

            </div>
          )}

        </div>
      </div>
    </div>
  );
}
